import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2 } from 'lucide-react';
export function AboutSection() {
  return <Section id="despre" background="blush" className="relative overflow-hidden" data-id="element-1">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-2">
        {/* Image Placeholder */}
        <div className="relative aspect-[4/5] rounded-2xl overflow-hidden shadow-xl bg-white" data-id="element-3">
          <div className="absolute inset-0 bg-brand-primary/5 flex items-center justify-center text-brand-primary/20" data-id="element-4">
            {/* Ideally replace with actual image */}
            <span className="text-lg font-medium" data-id="element-5">
              [Poza Daniela Sămărtinean]
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="space-y-8" data-id="element-6">
          <div data-id="element-7">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-2" data-id="element-8">
              Daniela Sămărtinean
            </h2>
            <p className="text-brand-primary font-medium text-lg mb-6" data-id="element-9">
              Psiholog Clinician & Psihoterapeut Integrativ • Facilitator Legile
              Universale • Mentor
            </p>

            <div className="space-y-6 text-gray-700 leading-relaxed" data-id="element-10">
              <p data-id="element-11">
                Sunt Daniela Sămărinean și lucrez cu oameni de succes
                profesional care, în interior, se confruntă cu anxietate, frici,
                dependențe emoționale sau comportamentale și cu o minte care nu
                se mai oprește din analizat.
              </p>
              <p data-id="element-12">
                Prin metoda mea 3S –{' '}
                <span className="font-semibold text-brand-primary" data-id="element-13">
                  Știință, Suflet și Spirit
                </span>{' '}
                – îi ghidez pe oameni să înțeleagă cauza reală a anxietății și
                fricilor lor, să vindece tiparele moștenite, să-și regăsească
                liniștea minții și puterea interioară.
              </p>
              <p data-id="element-14">
                Integrez Psihologia clinica, Psihoterapia Integrativă, Legile
                Universale și tehnici practice de reconectare cu corpul și cu
                Dumnezeu, pentru a susține vindecarea emoțională profundă și
                transformarea percepțiilor care le-au creat blocajele.
              </p>
            </div>
          </div>

          <div className="bg-white/50 p-6 rounded-xl border border-brand-primary/10" data-id="element-15">
            <h3 className="font-serif text-xl font-bold text-brand-text mb-4" data-id="element-16">
              Misiunea mea
            </h3>
            <ul className="space-y-3" data-id="element-17">
              {['De la frică la claritate', 'De la haos mental la liniște', 'De la deconectare la echilibru interior'].map((item, i) => <li key={i} className="flex items-center text-gray-700" data-id="element-18">
                  <CheckCircle2 className="w-5 h-5 text-brand-accent mr-3 flex-shrink-0" data-id="element-19" />
                  <span data-id="element-20">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}